import { IconButton, Theme } from "@mui/material"
import React from "react"
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';

const DarkModeButton = ({ toggleDarkMode, theme }: { toggleDarkMode: () => void, theme: Theme }) => {
    return (
        <IconButton sx={{ ml: 1 }} onClick={toggleDarkMode} color="inherit">
            {theme.palette.mode === 'dark' ? <BedtimeIcon /> : <LightModeIcon />}
        </IconButton>
    )
}

export default DarkModeButton